import { CheckCircle2, Clock3, XCircle } from 'lucide-react';
import { useEffect, useRef } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useCommerce } from '../contexts/CommerceContext';

const content = {
  success: {
    icon: CheckCircle2,
    title: 'Pagamento enviado.',
    description: 'Recebemos o retorno do Mercado Pago. A confirmação final aparecerá em Minha conta assim que o pagamento for validado.',
  },
  pending: {
    icon: Clock3,
    title: 'Pagamento em análise.',
    description: 'O Mercado Pago ainda está processando o pagamento. Você pode acompanhar a atualização em Minha conta.',
  },
  failure: {
    icon: XCircle,
    title: 'Pagamento não concluído.',
    description: 'Nenhuma cobrança foi confirmada. Você pode voltar ao checkout e tentar novamente.',
  },
} as const;

export function PaymentReturnPage() {
  const [params] = useSearchParams();
  const { clearCart } = useCommerce();
  const status = params.get('status');
  const state = status === 'success' || status === 'pending' || status === 'failure' ? status : 'pending';
  const view = content[state];
  const Icon = view.icon;
  const cartWasCleared = useRef(false);

  useEffect(() => {
    if (state === 'success' && !cartWasCleared.current) {
      cartWasCleared.current = true;
      clearCart();
    }
  }, [state, clearCart]);

  return (
    <main className="page-shell checkout-page">
      <div className="empty-state payment-return">
        <Icon size={42} strokeWidth={1.4} aria-hidden="true" />
        <p className="eyebrow">Mercado Pago</p>
        <h1>{view.title}</h1>
        <p>{view.description}</p>
        <div className="hero-actions">
          <Link className="button button-dark" to="/minha-conta">Ver meus pedidos</Link>
          {state === 'failure' && <Link className="button button-light" to="/checkout">Tentar novamente</Link>}
          {state !== 'failure' && <Link className="text-link" to="/fitness">Continuar comprando</Link>}
        </div>
      </div>
    </main>
  );
}
